import * as React from 'react';
import { Outside } from '../../../services';
import * as styles from './styles.module.css';
export function SelectDropdown(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    insideRefs = _ref.insideRefs;
  return /*#__PURE__*/React.createElement(Outside, {
    onOutside: onClose,
    active: true,
    insideRefs: insideRefs
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['dropdown']
  }, children));
}